import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import CSSTransition from "react-transition-group/Transition";
import styles from "./notification.module.scss";
import { hideNotification } from "../../store/notification/notificationActions";
import { getNotification } from "../../store/notification/notificationsSelectors";
import { INotificationItem } from "../../store/notification/notificationTypes";
import ErrorNotification from "./components/error/ErrorNotification";
import { activeRoute } from "../../store/navigation/navigationSelectors";
import SuccessNotification from "./components/success/SuccessNotification";
import { useTranslation } from "react-i18next";

const duration = 300;

const Notification = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const nodeRef = useRef<HTMLDivElement | null>(null);
  let defaultTimeOut = 4000;
  const notification = useSelector(getNotification);
  const currentRoute = useSelector(activeRoute);

  if (notification) {
    setTimeout(() => {
      dispatch(hideNotification());
    }, props.timeout || defaultTimeOut);
  }

  const getNotificationType = (notification: INotificationItem) => {
    let NotificationComponent;

    if (notification && notification?.kind) {
      const kind = notification?.kind;
      switch (kind) {
        case "error":
          NotificationComponent = ErrorNotification;
          break;
        case "success":
          NotificationComponent = SuccessNotification;
          break;
        default:
          NotificationComponent = ErrorNotification;
      }
    }

    return (
      <NotificationComponent
        className={`${styles.gaNotificationPanel} ${
          props?.className && props.className
        }`}
        title={t(notification?.title) || ""}
        label={notification?.subtitle ? t(notification?.subtitle) : ""}
        closeButton
      />
    );
  };

  return (
    <CSSTransition
      in={!!notification}
      timeout={
        notification?.duration && notification?.duration > 0
          ? notification.duration
          : duration
      }
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      unmountOnExit
      nodeRef={nodeRef}>
      <div
        ref={nodeRef}
        className={`${styles.gaNotification} ${props?.className} ${
          currentRoute === "login" ? styles.gaPublicNotification : ""
        }`}>
        {notification && getNotificationType(notification)}
      </div>
    </CSSTransition>
  );
};

export default Notification;
